import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { todayISO } from "@/lib/format";
import { WeekGrid, mondayOf, addDays } from "@/components/WeekGrid";

export function AttendanceWidget() {
  const [week, setWeek] = useState(null);
  useEffect(() => {
    const monday = mondayOf(todayISO());
    api.get("/admin/attendance", { params: { start: monday, end: addDays(monday, 6) } }).then((r) => setWeek(r.data));
  }, []);
  const absentToday = (week?.rows || [])
    .filter((r) => r.days.some((d) => d.date === todayISO() && !d.partial && !["presente", "non_lavorativo", "da_rilevare", "non_rilevato"].includes(d.state)))
    .map((r) => r.technician.name);
  return (
    <section className="mt-10 rounded-2xl border bg-white" data-testid="dashboard-attendance">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b px-5 py-4">
        <h2 className="font-display text-lg font-semibold">Presenze della settimana</h2>
        <div className="flex items-center gap-4">
          <span className="text-sm text-slate-500" data-testid="dashboard-absent-today">
            Assenti oggi: <b className="text-slate-900">{absentToday.length ? absentToday.join(", ") : "nessuno"}</b>
          </span>
          <Link to="/admin/presenze" className="flex items-center gap-1 rounded-full border border-[#61a229] px-3 py-1 text-sm text-[#61a229] transition-colors hover:bg-[#61a229] hover:text-white" data-testid="dashboard-attendance-link">Calendario <ArrowUpRight className="h-3.5 w-3.5" /></Link>
        </div>
      </div>
      <Link to="/admin/presenze" className="block p-2 transition-colors hover:bg-slate-50" data-testid="dashboard-attendance-grid-link"><WeekGrid data={week} compact /></Link>
    </section>
  );
}
